import { WalletConnectButton } from "@/app/wallet-connect"
import { Trans } from "@lingui/macro"
import { cn } from "@rarible_int/anaconda_ui_components"

interface Props {
  className?: string
}

export function WalletConnectPrompt(props: Props) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-4",
        props.className,
      )}
    >
      <div className="flex max-w-[600px] flex-col items-center gap-2">
        <div className="flex flex-col items-center gap-1">
          <h2 className="text-center text-2xl">
            <Trans>Wallet is not connected!</Trans>
          </h2>
          <span className="text-center text-foreground/60">
            <Trans>Please connect your wallet to see the items</Trans>
          </span>
        </div>
      </div>
      <WalletConnectButton />
    </div>
  )
}
